<script>
import { create } from "lodash";

export default {
    data: () => ({
        show: false,
        isModalOpen: true,
        userAgent: false,
        agent: "",
    }),

    created() {
        this.getMobileOS();
        this.createGooglePlayLink();
    },

    methods: {
        getMobileOS() {
            const ua = navigator.userAgent;
            if (/android/i.test(ua)) {
                this.userAgent = true;
                this.agent = "Android";
                return "Android";
            } else if (/iPad|iPhone|iPod/.test(navigator.userAgent)) {
                this.userAgent = true;
                this.agent = "iOS";
                return "iOS";
            }

            return "Other";
        },
        createGooglePlayLink() {
            function getCookie(name) {
                const cookies = document.cookie.split("; ");
                for (let cookie of cookies) {
                    const [key, value] = cookie.split("=");
                    if (key === name) {
                        return decodeURIComponent(value);
                    }
                }
                return null;
            }

            let utm_source = getCookie("utm_source");
            let utm_medium = getCookie("utm_medium");
            let utm_campaign = getCookie("utm_campaign");

            return `intent://tvcom.uz/?referrer=${encodeURIComponent(`utm_source=${utm_source}&utm_medium=${utm_medium}&utm_campaign=${utm_campaign}`)}#Intent;scheme=https;package=uz.comnet.tvcomstb;end`;
        },
        gotTo() {
            setTimeout(function () {
                window.location =
                    "https://apps.apple.com/uz/app/tvcom/id6479690034";
            }, 25);
            window.location = "tvcom://";
        },
    },
};
</script>

<template>
    <div class="smart_banner_wrap" v-if="isModalOpen && userAgent">
        <div class="app_img_wrap">
            <img src="../../assets/icons/tvcom-icon.webp" alt="Tvcom" />
        </div>
        <div class="descr_wrap">
            <h3>{{ $t("message.watch_tv_series_and_films") }}</h3>
            <div class="btns_wrap">
                <a
                    :href="createGooglePlayLink()"
                    v-if="agent === 'Android'"
                    class="link"
                    >{{ $t("message.watch_android") }}</a
                >
                <div class="link" @click="gotTo()" v-if="agent === 'iOS'">
                    {{ $t("message.watch_android") }}
                </div>
                <button @click="isModalOpen = false">
                    {{ $t("message.close") }}
                </button>
            </div>
        </div>
    </div>
</template>

<style scoped>
.smart_banner_wrap {
    max-width: 400px;
    width: 95%;
    background: #ffffff;
    border-radius: 20px;
    position: fixed;
    bottom: 50px;
    left: 50%;
    transform: translate(-50%);
    padding: 15px;
    display: grid;
    grid-template-columns: 1fr 2fr;
    z-index: 100000;
    box-shadow: 2px 2px 10px 0px black;
}

.app_img_wrap {
    border-radius: 16px;
    overflow: hidden;
    width: 100px;
    height: 100px;
    box-shadow: 0 2px 4px #686868;
}

.app_img_wrap > img {
    width: 100%;
    height: 100%;
    object-fit: scale-down;
}

.descr_wrap {
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 6px 0;
}

.descr_wrap > h3 {
    color: #000000;
    font-size: 15px;
    font-weight: 500;
}

.btns_wrap {
    display: flex;
    gap: 10px;
}

.btns_wrap > button {
    background: none;
    padding: 0 15px;
    border-radius: 8px;
    border: 1px solid rgb(0, 0, 0);
    color: rgb(0, 0, 0);
    font-size: 16px;
}

.btns_wrap > .link {
    border: 1px solid black;
    text-decoration: none;
    background: black;
    color: white;
    border-radius: 8px;
    width: fit-content;
    padding: 10px 15px;
    font-size: 16px;
}

@media screen and (max-width: 370px) {
    .app_img_wrap {
        width: 85px;
        height: 85px;
    }
    .btns_wrap > .link {
        padding: 10px;
        font-size: 14px;
    }
}
</style>
